import { createContext, type ReactNode } from "react";

import { type NavigationItem } from "@vega-core/models/navigation";

import { type MenuItems } from "../Deprecated/DropdownMenu/MenuItems.type";
import type { NavbarItem } from "../Navigation/Navbar/Navbar";

export type LayoutContextProps = {
  navigationItems: NavigationItem[];
  secondaryMenuItems: MenuItems[][];
  navbarItems?: NavbarItem[];
  navbarUserMenuItems?: NavbarItem[];
  navBarCustomNode?: ReactNode;
  onNavigate?: (analyticsSelector?: string) => void;
  setNavBarCustomNode?: (node: ReactNode | undefined) => void;
};

export const LayoutContext = createContext<LayoutContextProps>({
  navigationItems: [],
  secondaryMenuItems: [],
  navbarItems: [],
  navbarUserMenuItems: [],
});
